import React from 'react';

const StatusFooter = (props) => {
    if (props.purchase.cityads_pixel_url) {
        const script = document.createElement('script');
        script.src = props.purchase.cityads_pixel_url;
        script.async = true;
        document.body.appendChild(script);
    }
    return (
        <React.Fragment>
            <p className="msg-tks">
                <img
                    className="img-s2"
                    src="/assets/images/s2.svg"
                    alt="icon-grate"
                />
                <br /> Obrigado pela preferência. <br /> É um prazer poder lhe atender!
            </p>

            {props.purchase.actionpay_pixel_url && (
                <img
                    src={props.purchase.actionpay_pixel_url}
                    width="1"
                    height="1"
                    alt="pixel"
                />
            )}

            {props.purchase.meliuz_pixel_url && (
                <img
                    src={props.purchase.meliuz_pixel_url}
                    width="1"
                    height="1"
                    alt="pixel"
                />
            )}
        </React.Fragment>
    )
}

export default StatusFooter;



// WEBPACK FOOTER //
// ./src/components/purchase_status/StatusFooter.jsx